import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Applicant, IDVData } from '@shared/models/data-model';
import { IdvService } from '@shared/services/idv.service';
import { RegistrationService } from '@shared/services/registration.service';
import { APP_CONFIG, AppConfig } from '@src/app/app-config.module';
import { DTRUM_ACTION_NAME, DynatraceHelperService } from '../../shared/services/dynatraceHelper.service';

@Component({
    selector: 'applicant-pre-idv-page',
    templateUrl: './applicant-pre-idv-page.component.html',
    styleUrl: './applicant-pre-idv-page.component.scss'
})
export class ApplicantPreIdvPageComponent implements OnInit {

    loading: boolean = true;
    applicantFirstName: string = '';
    necessaryIdvSteps: string[] = [
        "STEP_OPEN_LINK",
        "STEP_UPLOAD_ID",
        "STEP_RECORD_VIDEO"
    ];
    idvHelpPageUrl: string = null;
    privacyPolicyLink: string = null;
    postRegistrationInfoUrl: string = null;
    applicantMustIdv: boolean = false;

    constructor(
        @Inject(APP_CONFIG) private readonly config: AppConfig,
        private readonly router: Router,
        private readonly idvService: IdvService,
        private readonly registrationService: RegistrationService,
        private readonly translateService: TranslateService,
        private readonly route: ActivatedRoute,
        private readonly dynatrace: DynatraceHelperService
    ) { }

    ngOnInit(): void {
        this.registrationService.deactivateProgressBar();
        this.translateService.onLangChange.subscribe(e => {
            this.handleLanguageChange(e.lang);
        });
        this.handleLanguageChange(this.translateService.getCurrentLang());

        switch (this.registrationService.getCountryOfIncorporation()) {
            case "GBR":
                this.privacyPolicyLink = this.config.privacyPolicyLink.en;
                this.idvHelpPageUrl = this.config.registrationProcessHelpURLs.fallback;
                break;
            case "ITA":
                this.privacyPolicyLink = this.config.privacyPolicyLink.it;
                this.idvHelpPageUrl = this.config.registrationProcessHelpURLs.ITA;
                break;
            default:
                this.privacyPolicyLink = this.config.privacyPolicyLink.fallback;
                this.idvHelpPageUrl = this.config.registrationProcessHelpURLs.fallback;
                break;
        }
        const applicant: Applicant = this.route.snapshot.data.applicantPreIdvData.applicant;
        const idvData: IDVData[] = this.route.snapshot.data.applicantPreIdvData.idvData;
        this.applicantFirstName = applicant.firstName;
        if (idvData) {
            const applicantIDVData = idvData.find(data => data.contactId === applicant.contactId);
            this.applicantMustIdv = Boolean(applicantIDVData?.idvReference);
            if (this.applicantMustIdv) {
                this.idvService.setCurrentIdvSessionData(applicantIDVData);
            }
            const poaRequired = idvData?.some(data => data.identityVerificationSteps?.split(',').includes('POA'));
            if (poaRequired) {
                this.necessaryIdvSteps.splice(2, 0, "STEP_UPLOAD_POA");
            }
        }
        this.loading = false;
    }

    handleLanguageChange(lang: string) {
        this.postRegistrationInfoUrl = this.config.postRegistrationInfoURLs[lang] || this.config.postRegistrationInfoURLs.fallback;
    }

    proceedToIDV(): void {
        const toIdvActionId = this.dynatrace.enterAction(`${DTRUM_ACTION_NAME.IDV_START} with onfido`);
        this.router.navigate(['static/verify-with-onfido']).then(() => {
            this.dynatrace.leaveAction(toIdvActionId);
        });
    }

    onClickCTA(): void {
        if (this.applicantMustIdv) {
            window.open(this.postRegistrationInfoUrl);
        } else {
            window.location.assign(this.postRegistrationInfoUrl);
        }
    }
}
